import { Link } from "react-router-dom";
import ArrowLeft from "../icons/ArrowLeft";


export type BreacrumbType = {path: string, label: string}

type BreadcrumbProps = {
  items: BreacrumbType[];
  startIndex?: number;
}

const Breadcrumb = ({items, startIndex}: BreadcrumbProps) => {
  let breadcrumb = [...items];

  if (startIndex) {
    breadcrumb = items.slice(startIndex);
  }

  function getLocation(index: number) {
    const i = startIndex ? index + startIndex : index;
    return items.slice(0, (i)).map(item => item.path).join('/');
  }
  
  return (
    <nav className="flex" aria-label="Feature breadcrumb">
      <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        {
          breadcrumb.map((item, index) => (
            <li key={index}>
              <div className="flex items-center">
                <ArrowLeft className="w-3" />
                <Link to={index === breadcrumb.length - 1 ? '' : getLocation(index + 1)}
                  className={`ms-1 md:ms-2 text-sm font-bold capitalize hover:underline
                    ${index === breadcrumb.length - 1 ? 'text-primary pointer-events-none' : ''}`}>
                  {item.label}
                </Link>
              </div>
            </li>
          ))
        }
      </ol>
    </nav>
  )
}

export default Breadcrumb;